export { default } from './InstruccionsIngres';
